import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { API_SETTINGS_MOCK } from '@core/mock/api-settings.mock';
import { Observable, delay, of } from 'rxjs';
import { APP_API_ENDPOINTS } from '../constants/app-api.const';

/**
 * Mock HTTP Interceptor để giả lập hành vi của Backend
 * Dùng cho mục đích phát triển khi chưa có API thật.
 */
export const mockHttpInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const { url, method } = req;

  // 1. Handshake: Init Session
  // if (url.includes(APP_API_ENDPOINTS.AUTH.INIT_SESSION) && method === 'POST') {
  //   return of(
  //     new HttpResponse({ status: 200, body: AUTH_MOCK.initSession }),
  //   ).pipe(delay(800));
  // }

  // 2. Authentication: Login
  // if (url.includes(APP_API_ENDPOINTS.AUTH.LOGIN) && method === 'POST') {
  //   const loginToken = headers.get('Authorization');

  //   // Giả lập kiểm tra Handshake
  //   if (loginToken && loginToken.includes('mock-handshake-token')) {
  //     return of(
  //       new HttpResponse({ status: 200, body: AUTH_MOCK.loginSuccess }),
  //     ).pipe(delay(1200));
  //   } else {
  //     return of(
  //       new HttpResponse({
  //         status: 200, // Backend thường trả 200 kèm status: false cho Business logic lỗi
  //         body: AUTH_MOCK.loginFailed,
  //       }),
  //     ).pipe(delay(500));
  //   }
  // }

  // 2.1 Get OTP
  // if (url.includes(APP_API_ENDPOINTS.AUTH.GET_OTP) && method === 'POST') {
  //   return of(
  //     new HttpResponse({ status: 200, body: AUTH_MOCK.getOtpSuccess }),
  //   ).pipe(delay(800));
  // }

  // 2.2 Confirm OTP
  // if (url.includes(APP_API_ENDPOINTS.AUTH.VERIFY_OTP) && method === 'POST') {
  //   return of(
  //     new HttpResponse({ status: 200, body: AUTH_MOCK.confirmOtpSuccess }),
  //   ).pipe(delay(800));
  // }

  // 2.3 Reset Password
  // if (
  //   url.includes(APP_API_ENDPOINTS.AUTH.CHANGE_PASSWORD) &&
  //   method === 'POST'
  // ) {
  //   return of(
  //     new HttpResponse({ status: 200, body: AUTH_MOCK.resetPasswordSuccess }),
  //   ).pipe(delay(1000));
  // }

  // 3. User info
  // if (url.includes(APP_API_ENDPOINTS.USER.INFO) && method === 'GET') {
  //   return of(new HttpResponse({ status: 200, body: AUTH_MOCK.userInfo })).pipe(
  //     delay(500),
  //   );
  //   return next(req);
  // }

  // 3.1 Change Password
  // if (
  //   url.includes(APP_API_ENDPOINTS.AUTH.CHANGE_PASSWORD) &&
  //   method === 'POST'
  // ) {
  //   // const body = req.body as ChangePasswordModel;
  //   // const isOldPassValid = body?.old_password === 'admin123';
  //   const isOldPassValid = false;

  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: isOldPassValid
  //         ? AUTH_MOCK.changePasswordSuccess
  //         : AUTH_MOCK.changePasswordFailed,
  //     }),
  //   ).pipe(delay(isOldPassValid ? 1000 : 500));
  // }

  // 4. Employee Role Groups (Nhóm quyền nhân viên)
  // if (url.includes(APP_API_ENDPOINTS.PERMISSION_GROUPS.BASE)) {
  //   // GET: Danh sách hoặc Chi tiết
  //   if (method === 'GET') {
  //     const parts = url.split('/');
  //     const id = parseInt(parts[parts.length - 1]);

  //     if (!isNaN(id)) {
  //       return of(
  //         new HttpResponse({
  //           status: 200,
  //           body: PERMISSION_GROUPS_MOCKS.getDetail(id),
  //         }),
  //       ).pipe(delay(300));
  //     }

  //     const params = {
  //       name: req.params.get('name') || '',
  //       page: parseInt(req.params.get('page') || '1'),
  //       pageSize: parseInt(req.params.get('pageSize') || '10'),
  //     };
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: PERMISSION_GROUPS_MOCKS.getList(params),
  //       }),
  //     ).pipe(delay(500));
  //   }

  //   // POST/PUT/DELETE: Thao tác CRUD
  //   if (['POST', 'PUT', 'DELETE'].includes(method)) {
  //     const action =
  //       method === 'POST'
  //         ? 'Created'
  //         : method === 'PUT'
  //           ? 'Updated'
  //           : 'Deleted';
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: PERMISSION_GROUPS_MOCKS.successResponse(
  //           `Mock ${action} Successful`,
  //         ),
  //       }),
  //     ).pipe(delay(800));
  //   }
  // }

  // 5. Employees Management (Nhân sự)
  // Sử dụng literal string '/users' để tránh sai lệch const và bắt được URL chính xác
  // if (url.includes('/users')) {
  //   // 5.1 Status Toggle API (PUT /users/:id/status)
  //   if (url.includes('/status') && method === 'PUT') {
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: EMPLOYEES_MOCKS.successResponse('Status Updated Successfully'),
  //       }),
  //     ).pipe(delay(600));
  //   }

  //   // 5.2 GET: List or Detail
  //   if (method === 'GET') {
  //     const parts = url.split('?')[0].split('/');
  //     const lastPart = parts[parts.length - 1];
  //     const id = parseInt(lastPart);

  //     // Nếu là số -> Get Detail
  //     if (!isNaN(id)) {
  //       return of(
  //         new HttpResponse({
  //           status: 200,
  //           body: EMPLOYEES_MOCKS.getDetail(id),
  //         }),
  //       ).pipe(delay(300));
  //     }

  //     // 5.2.2 Get List
  //     const mockParams = {
  //       keyword: req.params.get('keyword') || '',
  //       role_id: req.params.get('role_id') || '',
  //       is_active:
  //         req.params.get('status') || req.params.get('is_active') || '',
  //       page: parseInt(req.params.get('page') || '1'),
  //       pageSize: parseInt(req.params.get('pageSize') || '10'),
  //     };

  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: EMPLOYEES_MOCKS.getList(mockParams),
  //       }),
  //     ).pipe(delay(500));
  //   }

  //   // 5.3 POST/PUT/DELETE: CRUD operations
  //   if (['POST', 'PUT', 'DELETE'].includes(method)) {
  //     const action =
  //       method === 'POST'
  //         ? 'Created'
  //         : method === 'PUT'
  //           ? 'Updated'
  //           : 'Deleted';
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: EMPLOYEES_MOCKS.successResponse(
  //           `Mock Employee ${action} Successfully`,
  //         ),
  //       }),
  //     ).pipe(delay(800));
  //   }
  // }

  // 6. Location (Địa giới hành chính)
  // if (url.includes(APP_API_ENDPOINTS.LOCATION.PROVINCES) && method === 'GET') {
  //   const keyword = req.params.get('keyword') || undefined;
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: LOCATIONS_MOCK.getProvinces(keyword),
  //     }),
  //   ).pipe(delay(200));
  // }

  // if (url.includes(APP_API_ENDPOINTS.LOCATION.WARDS) && method === 'GET') {
  //   const provinceCode = req.params.get('province_code');
  //   const keyword = req.params.get('keyword') || undefined;
  //   if (provinceCode) {
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: LOCATIONS_MOCK.getWards(provinceCode, keyword),
  //       }),
  //     ).pipe(delay(200));
  //   }
  // }

  // 7. Permission Assignment
  // if (
  //   url.includes(APP_API_ENDPOINTS.PERMISSION_GROUPS.BASE) &&
  //   method === 'GET'
  // ) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: PERMISSION_ASSIGNMENT_MOCKS.getGroups(),
  //     }),
  //   ).pipe(delay(200));
  // }

  // if (
  //   url.includes(APP_API_ENDPOINTS.PERMISSION_ASSIGNMENT.EMPLOYEES) &&
  //   method === 'GET'
  // ) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: PERMISSION_ASSIGNMENT_MOCKS.getEmployees(),
  //     }),
  //   ).pipe(delay(200));
  // }

  // if (
  //   url.includes(APP_API_ENDPOINTS.PERMISSION_ASSIGNMENT.BASE) &&
  //   method === 'GET'
  // ) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: PERMISSION_ASSIGNMENT_MOCKS.getPermissionTree(),
  //     }),
  //   ).pipe(delay(400));
  // }

  // if (
  //   url.includes(APP_API_ENDPOINTS.PERMISSION_ASSIGNMENT.BASE) &&
  //   method === 'POST'
  // ) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: PERMISSION_ASSIGNMENT_MOCKS.successResponse(
  //         'Mock Saved Successfully',
  //       ),
  //     }),
  //   ).pipe(delay(800));
  // }

  // if (
  //   url.includes(APP_API_ENDPOINTS.PERMISSION_ASSIGNMENT.RESET_USERS) &&
  //   method === 'DELETE'
  // ) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: PERMISSION_ASSIGNMENT_MOCKS.successResponse(
  //         'Mock Reset Successfully',
  //       ),
  //     }),
  //   ).pipe(delay(800));
  // }
  // 6. History warehouse (Lịch sử kho)
  // if (url.includes(APP_API_ENDPOINTS.HISTORY.BASE)) {
  //   if (method === 'GET') {
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: WAREHOUSE_TRANSFER_MOCKS.getList(),
  //       }),
  //     ).pipe(delay(500));
  //   }
  // }

  // 5. Warehouses Management (Kho)
  // if (url.includes('/warehouses')) {
  //   // 5.1 Status Toggle
  //   if (url.includes('/status') && method === 'PUT') {
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: WAREHOUSES_MOCKS.successResponse('Status Updated Successfully'),
  //       }),
  //     ).pipe(delay(600));
  //   }

  //   // GET
  //   if (method === 'GET') {
  //     const parts = url.split('?')[0].split('/');
  //     const lastPart = parts[parts.length - 1];
  //     const id = parseInt(lastPart);

  //     if (!isNaN(id)) {
  //       return of(
  //         new HttpResponse({
  //           status: 200,
  //           body: WAREHOUSES_MOCKS.getDetail(id),
  //         }),
  //       ).pipe(delay(300));
  //     }

  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: WAREHOUSES_MOCKS.getList(),
  //       }),
  //     ).pipe(delay(500));
  //   }

  //   // CRUD
  //   if (['POST', 'PUT', 'DELETE'].includes(method)) {
  //     const action =
  //       method === 'POST'
  //         ? 'Created'
  //         : method === 'PUT'
  //           ? 'Updated'
  //           : 'Deleted';

  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: WAREHOUSES_MOCKS.successResponse(
  //           `Mock Warehouse ${action} Successfully`,
  //         ),
  //       }),
  //     ).pipe(delay(800));
  //   }
  // }

  // 8.1 Activity Log Dashboard
  // if (
  //   url.includes(APP_API_ENDPOINTS.USER_ACTIVITIES.DASHBOARD) &&
  //   method === 'GET'
  // ) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: {
  //         status: true,
  //         mess: 'Success',
  //         data: ACTIVITY_LOG_MOCKS.getDashboard(),
  //       },
  //     }),
  //   ).pipe(delay(400));
  // }

  // if (
  //   url.includes(APP_API_ENDPOINTS.USER_ACTIVITIES.BASE) &&
  //   method === 'GET'
  // ) {
  //   const params = {
  //     page: parseInt(req.params.get('page') || '1'),
  //     page_size: parseInt(req.params.get('page_size') || '10'),
  //   };
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: ACTIVITY_LOG_MOCKS.getList(params),
  //     }),
  //   ).pipe(delay(600));
  // }

  // 9. Dashboard Overview
  // if (url.includes(APP_API_ENDPOINTS.DASHBOARD.OVERVIEW) && method === 'GET') {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: {
  //         status: true,
  //         mess: 'Success',
  //         data: DASHBOARD_OVERVIEW_MOCK,
  //       },
  //     }),
  //   ).pipe(delay(400));
  // }

  // 10. KPI Camera Data
  // if (url.includes(APP_API_ENDPOINTS.KPI_CAMERA.DATA) && method === 'GET') {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: {
  //         status: true,
  //         mess: 'Success',
  //         data: KPI_CAMERA_MOCK,
  //       },
  //     }),
  //   ).pipe(delay(400));
  // }

  // if (
  //   url.includes(APP_API_ENDPOINTS.CORE_NOTIFICATIONS.COUNT_UNREAD) &&
  //   method === 'GET'
  // ) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: {
  //         status: true,
  //         mess: 'Success',
  //         data: {
  //           count: NOTIFICATION_MOCK.filter((item) => !item.isRead).length,
  //         },
  //       },
  //     }),
  //   ).pipe(delay(250));
  // }

  // if (
  //   url.includes(APP_API_ENDPOINTS.CORE_NOTIFICATIONS.MARK_ALL_AS_READ) &&
  //   method === 'PATCH'
  // ) {
  //   NOTIFICATION_MOCK.forEach((item) => {
  //     item.isRead = true;
  //   });

  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: {
  //         status: true,
  //         mess: 'Success',
  //         data: null,
  //       },
  //     }),
  //   ).pipe(delay(250));
  // }

  // if (
  //   url.includes(APP_API_ENDPOINTS.CORE_NOTIFICATIONS.BASE) &&
  //   url.endsWith('/read') &&
  //   method === 'PATCH'
  // ) {
  //   const parts = url.split('/');
  //   const id = parseInt(parts[parts.length - 2]);

  //   NOTIFICATION_MOCK.forEach((item) => {
  //     if (item.id === id) {
  //       item.isRead = true;
  //     }
  //   });

  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: {
  //         status: true,
  //         mess: 'Success',
  //         data: null,
  //       },
  //     }),
  //   ).pipe(delay(250));
  // }

  // if (
  //   url.includes(APP_API_ENDPOINTS.CORE_NOTIFICATIONS.BASE) &&
  //   method === 'GET'
  // ) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: {
  //         status: true,
  //         mess: 'Success',
  //         data: NOTIFICATION_MOCK,
  //       },
  //     }),
  //   ).pipe(delay(300));
  // }

  // 7. Platform fee Management (Cấu hình phí nền tảng)
  // if (url.includes(APP_API_ENDPOINTS.SIM.PACKAGES)) {
  //   // GET
  //   if (method === 'GET') {
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: PLATFORM_FEE_MOCKS.getList(),
  //       }),
  //     ).pipe(delay(500));
  //   }

  //   // CRUD
  //   if (['POST', 'PUT', 'DELETE'].includes(method)) {
  //     const action =
  //       method === 'POST'
  //         ? 'Created'
  //         : method === 'PUT'
  //           ? 'Updated'
  //           : 'Deleted';

  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: PLATFORM_FEE_MOCKS.successResponse(
  //           `Mock Platform Fee ${action} Successfully`,
  //         ),
  //       }),
  //     ).pipe(delay(800));
  //   }
  // }

  // 11.Dịch vụ
  // if (url.includes(APP_API_ENDPOINTS.SERVICE.BASE)) {
  //   // 5.1 Status Toggle
  //   if (url.includes('/status') && method === 'PUT') {
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: WAREHOUSES_MOCKS.successResponse('Status Updated Successfully'),
  //       }),
  //     ).pipe(delay(600));
  //   }
  //   // GET
  //   if (method === 'GET') {
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: SERVICES_MOCKS.getList(),
  //       }),
  //     ).pipe(delay(500));
  //   }

  //   // CRUD
  //   if (['POST', 'PUT', 'DELETE'].includes(method)) {
  //     const action =
  //       method === 'POST'
  //         ? 'Created'
  //         : method === 'PUT'
  //           ? 'Updated'
  //           : 'Deleted';

  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: WAREHOUSES_MOCKS.successResponse(
  //           `Mock Warehouse ${action} Successfully`,
  //         ),
  //       }),
  //     ).pipe(delay(800));
  //   }
  // }

  // 12. Loại thiết bị
  // if (url.includes(APP_API_ENDPOINTS.DEVICE_TYPE.BASE)) {
  //   // 12.1 Status Toggle
  //   if (url.includes('/status') && method === 'PUT') {
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: DEVICE_TYPES_MOCKS.successResponse(
  //           'Status Updated Successfully',
  //         ),
  //       }),
  //     ).pipe(delay(600));
  //   }
  //   // GET
  //   if (method === 'GET') {
  //     const parts = url.split('?')[0].split('/');
  //     const lastPart = parts[parts.length - 1];
  //     const id = parseInt(lastPart);

  //     if (!isNaN(id)) {
  //       return of(
  //         new HttpResponse({
  //           status: 200,
  //           body: DEVICE_TYPES_MOCKS.getDetail(id),
  //         }),
  //       ).pipe(delay(300));
  //     }

  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: DEVICE_TYPES_MOCKS.getList(),
  //       }),
  //     ).pipe(delay(500));
  //   }

  //   // CRUD
  //   if (['POST', 'PUT', 'DELETE'].includes(method)) {
  //     const action =
  //       method === 'POST'
  //         ? 'Created'
  //         : method === 'PUT'
  //           ? 'Updated'
  //           : 'Deleted';

  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: DEVICE_TYPES_MOCKS.successResponse(
  //           `Mock Device Type ${action} Successfully`,
  //         ),
  //       }),
  //     ).pipe(delay(800));
  //   }
  // }

  // 13. Thiết bị
  // if (url.includes(APP_API_ENDPOINTS.DEVICE.BASE)) {
  //   // 13.1 Status Toggle
  //   if (url.includes('/status') && method === 'PUT') {
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: DEVICES_MOCKS.successResponse('Status Updated Successfully'),
  //       }),
  //     ).pipe(delay(600));
  //   }
  //   // GET
  //   if (method === 'GET') {
  //     const parts = url.split('?')[0].split('/');
  //     const lastPart = parts[parts.length - 1];
  //     const id = parseInt(lastPart);

  //     if (!isNaN(id)) {
  //       return of(
  //         new HttpResponse({
  //           status: 200,
  //           body: DEVICES_MOCKS.getDetail(id),
  //         }),
  //       ).pipe(delay(300));
  //     }

  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: DEVICES_MOCKS.getList(),
  //       }),
  //     ).pipe(delay(500));
  //   }

  //   // CRUD
  //   if (['POST', 'PUT', 'DELETE'].includes(method)) {
  //     const action =
  //       method === 'POST'
  //         ? 'Created'
  //         : method === 'PUT'
  //           ? 'Updated'
  //           : 'Deleted';

  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: DEVICES_MOCKS.successResponse(
  //           `Mock Device ${action} Successfully`,
  //         ),
  //       }),
  //     ).pipe(delay(400));
  //   }
  // }

  // if (
  //   url.includes(APP_API_ENDPOINTS.CORE_NOTIFICATIONS.COUNT_UNREAD) &&
  //   method === 'GET'
  // ) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: {
  //         status: true,
  //         mess: 'Success',
  //         data: {
  //           count: NOTIFICATION_MOCK.filter((item) => !item.isRead).length,
  //         },
  //       },
  //     }),
  //   ).pipe(delay(250));
  // }

  // if (
  //   url.includes(APP_API_ENDPOINTS.CORE_NOTIFICATIONS.MARK_ALL_AS_READ) &&
  //   method === 'PATCH'
  // ) {
  //   NOTIFICATION_MOCK.forEach((item) => {
  //     item.isRead = true;
  //   });

  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: {
  //         status: true,
  //         mess: 'Success',
  //         data: null,
  //       },
  //     }),
  //   ).pipe(delay(250));
  // }

  // if (
  //   url.includes(APP_API_ENDPOINTS.CORE_NOTIFICATIONS.BASE) &&
  //   url.endsWith('/read') &&
  //   method === 'PATCH'
  // ) {
  //   const parts = url.split('/');
  //   const id = parseInt(parts[parts.length - 2]);

  //   NOTIFICATION_MOCK.forEach((item) => {
  //     if (item.id === id) {
  //       item.isRead = true;
  //     }
  //   });

  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: {
  //         status: true,
  //         mess: 'Success',
  //         data: null,
  //       },
  //     }),
  //   ).pipe(delay(250));
  // }
  // if (
  //   url.includes(APP_API_ENDPOINTS.CORE_NOTIFICATIONS.BASE) &&
  //   method === 'GET'
  // ) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: {
  //         status: true,
  //         mess: 'Success',
  //         data: NOTIFICATION_MOCK,
  //       },
  //     }),
  //   ).pipe(delay(300));
  // }

  // 14. Quản lý SIM
  // if (url.includes(APP_API_ENDPOINTS.SIM.BASE)) {
  //   if (method === 'GET') {
  //     const parts = url.split('?')[0].split('/');
  //     const lastPart = parts[parts.length - 1];
  //     const id = parseInt(lastPart);

  //     if (!isNaN(id)) {
  //       // Get Detail (not implemented in mock handler for now, reuse list or return success)
  //       return of(
  //         new HttpResponse({
  //           status: 200,
  //           body: SIM_MOCK_HANDLERS.getById(id),
  //         }),
  //       ).pipe(delay(300));
  //     }

  //     const mockParams = {
  //       keyword: req.params.get('keyword') || '',
  //       provider: req.params.get('provider') || '',
  //       status: req.params.get('status') || '',
  //       page: parseInt(req.params.get('page') || '1'),
  //       page_size: parseInt(req.params.get('page_size') || '10'),
  //     };

  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: SIM_MOCK_HANDLERS.getList(mockParams),
  //       }),
  //     ).pipe(delay(500));
  //   }

  //   if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: { status: true, mess: 'Successful' },
  //       }),
  //     ).pipe(delay(800));
  //   }
  // }

  // 15. Quản lý Khách hàng (Customers)
  // if (url.includes('/customers')) {
  //   if (url.includes('/delete-request') && method === 'PUT') {
  //     const parts = url.split('/');
  //     const idIndex = parts.indexOf('customers') + 1;
  //     const id = parseInt(parts[idIndex]);
  //     const isDelete = !!(req.body as { delete?: boolean })?.delete;
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: CUSTOMERS_MOCKS.processDeleteRequest(id, isDelete),
  //       }),
  //     ).pipe(delay(600));
  //   }

  //   if (url.includes('/stats') && method === 'GET') {
  //     return of(
  //       new HttpResponse({ status: 200, body: CUSTOMERS_MOCKS.getStats() }),
  //     ).pipe(delay(300));
  //   }

  //   if (url.includes('/delete-requests') && method === 'GET') {
  //     const mockParams = {
  //       page: parseInt(req.params.get('page') || '1'),
  //       page_size: parseInt(req.params.get('page_size') || '10'),
  //     };
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: CUSTOMERS_MOCKS.getDeleteRequests(mockParams),
  //       }),
  //     ).pipe(delay(500));
  //   }

  // if (method === 'GET' && /\/customers\/\d+$/.test(url)) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: CUSTOMERS_MOCKS.getUserDetail(),
  //     }),
  //   ).pipe(delay(400));
  // }

  // if (method === 'GET' && /\/customers\/\d+\/devices$/.test(url)) {
  //   const parts = url.split('/');
  //   const idIndex = parts.indexOf('customers') + 1;
  //   const id = parseInt(parts[idIndex]);
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: CUSTOMERS_MOCKS.getDeviceListById(id),
  //     }),
  //   ).pipe(delay(400));
  // }

  //   if (method === 'GET') {
  //     const mockParams = {
  //       keyword: req.params.get('keyword') || '',
  //       page: parseInt(req.params.get('page') || '1'),
  //       page_size: parseInt(req.params.get('page_size') || '10'),
  //     };

  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: CUSTOMERS_MOCKS.getList(mockParams),
  //       }),
  //     ).pipe(delay(500));
  //   }
  // }

  // 6. History warehouse (Lịch sử kho)
  // if (url.includes(APP_API_ENDPOINTS.WAREHOUSE_REPORT.BASE)) {
  //   if (method === 'GET') {
  //     return of(
  //       new HttpResponse({
  //         status: 200,
  //         body: REPORT_WAREHOUSE_MOCKS.getList(),
  //       }),
  //     ).pipe(delay(500));
  //   }
  // }

  // 16. API Settings (Cài đặt API)
  if (
    url.includes(APP_API_ENDPOINTS.API_SETTINGS.CHECK_CONNECTION) &&
    method === 'POST'
  ) {
    return of(
      new HttpResponse({
        status: 200,
        body: API_SETTINGS_MOCK.checkConnection(),
      }),
    ).pipe(delay(1000));
  }

  if (url.includes(APP_API_ENDPOINTS.API_SETTINGS.BASE) && method === 'GET') {
    return of(
      new HttpResponse({
        status: 200,
        body: API_SETTINGS_MOCK.getData(),
      }),
    ).pipe(delay(500));
  }

  // if (method === 'GET' && /\/customers\/\d+\/oauth-accounts$/.test(url)) {
  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: CUSTOMERS_MOCKS.getOAuthAccounts(),
  //     }),
  //   ).pipe(delay(400));
  // }

  // 17. Service History Logs
  // if (url.includes('/services/') && url.includes('/logs') && method === 'GET') {
  //   const match = url.match(/\/services\/(\d+)\/logs/);
  //   const serviceId = match ? parseInt(match[1]) : 1;
  //   const page = parseInt(req.params.get('page') || '1');
  //   const pageSize = parseInt(req.params.get('page_size') || '5');

  //   return of(
  //     new HttpResponse({
  //       status: 200,
  //       body: SERVICES_MOCKS.getLogs(serviceId, page, pageSize),
  //     })
  //   ).pipe(delay(300));
  // }

  return next(req);
};
